import { X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { countryData } from "@/data/countryData";
import { useIsMobile } from "@/hooks/use-mobile";

interface SelectedCountriesProps {
  selectedCountries: string[];
  onCountrySelect: (countryCode: string) => void;
  onClearFilters: () => void;
}

export const SelectedCountries = ({ 
  selectedCountries, 
  onCountrySelect, 
  onClearFilters 
}: SelectedCountriesProps) => {
  const isMobile = useIsMobile();

  if (selectedCountries.length === 0) return null;

  return (
    <div className="flex flex-wrap gap-1.5 items-center">
      <div className="flex flex-wrap gap-1.5 items-center max-w-full">
        {selectedCountries.map((code) => (
          <Badge 
            key={code}
            variant="secondary"
            className="flex items-center gap-1 py-0.5 px-2 text-xs"
          >
            <img 
              src={countryData[code].flag} 
              alt={countryData[code].name}
              className="w-3 h-3 rounded-sm"
            />
            {!isMobile ? (
              <span className="max-w-[100px] truncate">{countryData[code].name}</span>
            ) : (
              <span className="max-w-[60px] truncate">{countryData[code].name}</span>
            )}
            <Button
              variant="ghost"
              size="sm"
              className="h-4 w-4 p-0 hover:bg-transparent ml-1"
              onClick={() => onCountrySelect(code)}
            >
              <X className="h-3 w-3" />
            </Button>
          </Badge>
        ))}
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={onClearFilters}
        className="text-xs h-6 px-2 hover:bg-destructive/10 hover:text-destructive"
      >
        Clear all
      </Button>
    </div>
  );
};